import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeInUpBigOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {UserService} from '../../../services/user.service';
import {ProgressModel} from '../../../services/models/progress.model';
import {ProgressService} from '../../../services/progress.service';
import {environment} from '../../../../environments/environment';
import {AnalyticsService} from '../../../services/analytics.service';
import {LeaderboardService} from '../service/leaderboard.service';
import {LeaderboardModel} from '../models/leaderboard.model';

@Component({
    selector: 'app-leaderboard-shoosmiths-page',
    templateUrl: 'leaderboard-shoosmiths.page.html',
    styleUrls: ['leaderboard-shoosmiths.page.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpBigOnEnterAnimation({anchor: 'enterUp', duration: 300}),
    ],
})
export class LeaderboardShoosmithsPage implements OnInit, OnDestroy {

    environment = null;
    menuVisible = true;

    leaderboardData: LeaderboardModel[] = null;
    leaderboardPromise: Promise<LeaderboardModel[]> = null;
    leaderboardValid = false;
    userType = null;

    progress: ProgressModel = null;
    progressPromise: Promise<ProgressModel> = null;
    progressValid = false;
    platform = 'website';

    timeout = null;
    section = null;

    type = 'top'; // top, cross, solutions, pricing, total
    order = ['top', 'phase1', 'phase2', 'phase3', 'total'];

    constructor(
        public authService: AuthService,
        private leaderboardService: LeaderboardService,
        public userService: UserService,
        private analytics: AnalyticsService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
        this.environment = environment;
    }

    ngOnInit(): void {
        this.platform = environment.platform;
        this.section = this.route.snapshot.paramMap.get("section") || null;

        if (this.order.includes(this.section)) {
            this.type = this.section;
        } else {
            this.section = null;
        }

        this.timeout = setInterval(() => {
            this.refresh();
        },  5 * 1000);
    }

    ionViewWillEnter() {
        this.leaderboardPromise = this.leaderboardService.getLeaderboard();
    }

    ionViewDidEnter() {
            this.leaderboardPromise.then(data => {
            this.leaderboardData = data;
            console.log(this.leaderboardData);
            this.leaderboardValid = true;
        });
    }

    refresh() {
        this.leaderboardService.getLeaderboard()
            .then(data => {
                if (this.section === null) {
                    const idx = this.order.indexOf(this.type);
                    if (idx < this.order.length - 1) {
                        this.type = this.order[idx + 1];
                    } else {
                        this.type = this.order[0];
                    }
                }
                this.leaderboardData = data;
                this.leaderboardValid = true;
            });
    }

    ngOnDestroy() {
        clearInterval(this.timeout);
    }
}
